import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './OpusEditor.html?raw';
import on from 'dojo/on';
import Edit from '../../../moreCore/UI/Edit/Edit';
import '../../../moreCore/UI/Edit/Edit';
import Number from '../../../moreCore/UI/NumberInput/NumberInput';
import '../../../moreCore/UI/NumberInput/NumberInput';
import Checkbox from '../../../moreCore/UI/CheckBox/CheckBox';
import '../../../moreCore/UI/CheckBox/CheckBox';
import Selectbox from '../../../moreCore/UI/SelectBox/SelectBox';
import "../../../moreCore/UI/SelectBox/SelectBox";
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import Button from '../../../moreCore/UI/Button/Button';
import "../../../moreCore/UI/Button/Button";
import OpusAddressList from '../../OpusManagement/OpusAddressList/OpusAddressList';


class OpusEditor extends compose(_WidgetBaseSP) {
    templateString: any = template;

    opusId;
    opus: Opus.OpusResponse = null;
    opusSubTitle: MdsLax<InstanceType<typeof Edit>>;
    opusInstrumentationCode: MdsLax<InstanceType<typeof Edit>>;
    opusTitle: MdsLax<InstanceType<typeof Edit>>;
    opusNote: MdsLax<InstanceType<typeof Edit>>;
    opusMovements: MdsLax<InstanceType<typeof Edit>>
    opusState: MdsLax<InstanceType<typeof Selectbox>>;
    opusDuration: MdsLax<InstanceType<typeof Number>>;
    opusCopyrightFeeObligation: MdsLax<InstanceType<typeof Checkbox>>;
    opusCreatedFrom: MdsLax<InstanceType<typeof Edit>>;
    opusCreatedTo: MdsLax<InstanceType<typeof Edit>>;
    opusFirstRelease: MdsLax<InstanceType<typeof Edit>>;


    selectionValue: SelectionValueEntity = null;
    _data_SelectionValues: Array<SelectionValueEntity>;

    btnAddAddress: MdsLax<InstanceType<typeof Button>>;
    addressList;
    addressInput: MdsLax<InstanceType<typeof HintBox>>;
    addressRelationType: MdsLax<InstanceType<typeof Selectbox>>;
    addressPrefix: MdsLax<InstanceType<typeof Edit>>;

    setOpusEntityId(entityId) {
        this.opusId = entityId;
        this._getOpusEntity();

        
    }

    _getOpusEntity() {
        //get Opus Entity from API
        var url = window.appRoot + "OpusManagement/GetOpusEntity";

        this.StandbyStart();
        let data = { opusId: this.opusId };

        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, this._onLoadOpusEntityResponse),
            lang.hitch(this, this._onLoadOpusEntityError),
            false // sync
        );
    }

    _onLoadOpusEntityResponse(response: Opus.OpusResponse) {
        this.opus = response;
        this.refreshSelectionValue();
        this._setValues();
        this.StandbyStop();
    }

    _onLoadOpusEntityError(err: more.requestErrorMessage) {
        alert("ERROR beim LoadRoomDetail: " + err.Message);
    }

    _getOpusStates() {
        var url = window.appRoot + "OpusManagement/GetOpusStates";
        this.StandbyStart(this.opusState.domNode);

        this.RequestManager.post(
            url,
            {},
            lang.hitch(this, this._onLoadOpusStatesResponse),
            lang.hitch(this, this._onLoadOpusStatesError),
            false // sync
        );
    }

    _onLoadOpusStatesResponse(response) {
        this._processOpusStateValues(response);
        this.StandbyStop();
    }

    _onLoadOpusStatesError(err: more.requestErrorMessage) {
        alert("ERROR beim _getOpusStates: " + err.Message);
    }

    _getOpusRelationTypes() {
        var url = window.appRoot + "OpusManagement/GetOpusRelationTypes";
        this.StandbyStart(this.addressRelationType.domNode);

        this.RequestManager.post(
            url,
            {},
            lang.hitch(this, this._onLoadOpusRelationTypesResponse),
            lang.hitch(this, this._onLoadOpusRelationTypesError),
            false // sync
        );
    }

    _onLoadOpusRelationTypesResponse(response) {
        this._processAddressRelationTypeValues(response);
        this.StandbyStop();
    }

    _onLoadOpusRelationTypesError(err: more.requestErrorMessage) {
        alert("ERROR beim _getOpusRelationTypes: " + err.Message);
    }

    saveOpus() {
        this._saveOpusData();
    }

    _saveOpusData() {
        //saves Opus entity

        let changedAddresses = this.addressList.addressListAll.filter(list => list.hasChanged === true);
        var url = window.appRoot + "OpusManagement/SaveOpusEntity";

        let data: OpusEntity.OpusPayload = { //: OpusEditor.OpusFormData
            entity: {
                opusId: this.opusId,
                opusTitle: this.opusTitle.getValue(),
                opusSubtitle: this.opusSubTitle.getValue(),
                opusNote: this.opusNote.getValue(),
                opusMovements: this.opusMovements.getValue(),
                opusInstrumentationCode: this.opusInstrumentationCode.getValue(),
                opusState: this.opusState.getValue(),
                addresses: changedAddresses,
                opusDuration: this.opusDuration.getValue(),
                opusCopyrightFeeObligation: this.opusCopyrightFeeObligation.getValue(),
                opusCreatedFrom: this.opusCreatedFrom.getValue(),
                opusCreatedTo: this.opusCreatedTo.getValue(),
                opusFirstRelease: this.opusFirstRelease.getValue(),

            }
        };

        this.StandbyStart();

        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, this._onSaveOpusDataResponse, data),
            lang.hitch(this, this._onSaveOpusDataError, data),
            false // sync
        );
    }

    _onSaveOpusDataResponse(response: any) {
        this.StandbyStop();
        this.emit("saveComplete");
    }

    _onSaveOpusDataError(err: more.requestErrorMessage) {
        alert("ERROR beim OpusData: " + err.Message);
    }

    _processAddressRelationTypeValues(items) {
        //set data for RelationTypeSelectbox
        this._data_SelectionValues = items;

        for (let entity of this._data_SelectionValues) {
            this.addressRelationType.addOption(entity.ID, entity.description, true);
        }

        this.addressRelationType.constructOptions();

        this.addressRelationType.startup();
    }

    _processOpusStateValues(items) {
        //set data for StateSelectbox
        this._data_SelectionValues = items;

        for (let entity of this._data_SelectionValues) {
            this.opusState.addOption(entity.ID, entity.description, true);
        }

        this.opusState.setBlankOption(null, this.translations["OpusFinder_PlaceholderSelectbox_State"]);

        this.opusState.constructOptions();

        this.opusState.startup();
        
    }

    refreshSelectionValue(): void {
        if (this.opus.ref_opus_status != null) {
            this.opusState.setValue(this.opus.ref_opus_status.ID, true)
        }
    }

    setDirty(isDirty: boolean) {
        this.emit("dirty", isDirty);
    }


    _onChange_OpusData() {
        this._validateOpusInput();
    }

    _onChange_AddressInput() {
        this._validateAddressInput();
    }

    _validateOpusInput() {
        this.opusTitle.setMandatory(true);
        let isOpusStateValid = this.opusState.getValue() != "null"; 
        let isOpusTitleValid = this.opusTitle.validateInput();

        if (isOpusStateValid && isOpusTitleValid) {
            this.setDirty(true);
        } else {
            this.setDirty(false);
        }

    }

    _validateAddressInput() {
        //check if save would be valid + enable save button

        this.addressInput.setMandatory(true)
        let addressInputFlag = this.addressInput.validateInput();
        let addresRelationTypeFlag = this.addressRelationType.validateInput();

        if (addressInputFlag && addresRelationTypeFlag) {
            this.UiModder.domClass.remove(this.btnAddAddress.domNode, "w3-disabled");
        } else {
            this.UiModder.domClass.add(this.btnAddAddress.domNode, "w3-disabled");
        }
    }

    _onAddAddressClick() {
        //link new address to opus
        let address = this.addressInput._getValueAttr();
        let addressRelationTypeLabel: string = this.addressRelationType.getMultipleValues(true)[0];
        let newAddressTemp: Array<Opus.OpusAddress> = [{
            "prefix": this.addressPrefix.getValue(),
            "order": this.addressList.addressListAll.length + 1,
            "hasChanged": true,
            "ref_address": { "ID": address["ID"], "gDisp_Firstname_Name": address["gDisp_FirstName_Name"] },
            "ref_relation_type": { "ID": this.addressRelationType.getValue(), "description": addressRelationTypeLabel }
        }];
        if (this.addressList.addressListAll.length == 0) {
            this.addressList.refreshTable(newAddressTemp)
        } else {
            this.addressList.addTableRows(newAddressTemp);
        }
        
        this.setDirty(true);
    }

    _validateInput() {

    }

    _setValues(): void {
        //set value from response
        this.opusSubTitle.setValue(this.opus.opus_subtitel_D, true);
        this.opusTitle.setValue(this.opus.opus_titel_D, true);
        this.opusNote.setValue(this.opus.note, true);
        this.opusInstrumentationCode.setValue(this.opus.instrumentation_code_1, true);
        this.opusMovements.setValue(this.opus.movements, true);
        this.opusDuration.setValue(this.opus.duration_min)
        this.opusCopyrightFeeObligation.setValue(this.opus.is_copyright_fee_obligation)
        this.opusCreatedFrom.setValue(this.opus.created_from)
        this.opusCreatedTo.setValue(this.opus.created_until)
        this.opusFirstRelease.setValue(this.opus.opus_first_release)

                

        this.addressList.refreshTable(this.opus.opusAddresses);
        on(this.addressList, "dirty", lang.hitch(this, this.setDirty, true));
        on(this.addressList, "deleted", lang.hitch(this, this._opusAddressDeleted));
        this.setDirty(false);
        
    }

    _opusAddressDeleted(entity, opusId) {
        let addressList = this.addressList.addressListAll.filter(data => data.ID != entity.ID);
        this.addressList.refreshTable(addressList);
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        //set Input Options
        this.opusNote.setIsMultiline(true);
        this.opusMovements.setIsMultiline(true);
        this.addressPrefix.setPlaceholder(this.translations["OpusFinder_PlaceholderInput_Prefix"]);
        this.addressRelationType.setPlaceholder(this.translations["OpusFinder_PlaceholderSelectbox_Function"]);
        this.addressInput.resetOnEdit = true;
        this.addressInput.enablePlainTextValue = false;
        this.opusState.setMandatory(true);


        //set validation Options
        this.addressInput.setValidationEnabled(true);
        this.addressRelationType.setMandatory(true);
        this.addressRelationType.setValidationEnabled(true);

        this.btnAddAddress.setLabel(this.translations["OpusFinder_LabelBtn_AddAddress"]);
        this.btnAddAddress.setIconLeft("fas fa-plus");
        this.btnAddAddress.setClasses("accentBG mds-hover-bright");
        this.UiModder.domClass.add(this.btnAddAddress.domNode, "w3-disabled");

        this._getOpusStates();
        this._getOpusRelationTypes();

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(OpusEditor.prototype, {
  addressList: () => (new OpusAddressList()),
});
export default mdsWidget(OpusEditor);